export default "__VITE_ASSET__8Kt1Qnuj__"